import * as React from 'react';
import { useSelector } from 'react-redux';

import { Content, FullscreenPopup } from '../../components/FullscreenPopup';
import { InteriorDecoration } from '../../components/InteriorDecoration';
import { Layout } from '../../components/Layout';
import { getProductsData } from '../../selectors/analytics';
import { getBuilders, getNewbuildingId, getInteriorDecoration } from '../../selectors/newbuilding';
import { AsideContentPopupHeader } from '../AsideContentPopupHeader';
import { trackClickInteriorDecoration } from './tracking';

const INTERIOR_POPUP_FAVORITE_EVENT_ACTIONS = {
  add: 'add_from_jk_finish',
  remove: 'remove_from_jk_finish',
};

export function InteriorDecorationContainer() {
  const list = useSelector(getInteriorDecoration);
  const builder = useSelector(getBuilders)[0] || null;
  const id = useSelector(getNewbuildingId);
  const products = [getProductsData(id, builder)];
  const [isOpened, setOpenedState] = React.useState(false);
  const [index, setIndex] = React.useState(0);

  const onItemClick = React.useCallback(
    (i: number) => {
      setIndex(i);
      setOpenedState(true);
      trackClickInteriorDecoration(products)(list[i].type);
    },
    [setOpenedState, setIndex],
  );

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  if (!list.length) {
    return null;
  }

  const item = list[index];

  return (
    <Layout>
      <InteriorDecoration items={list} onItemClick={onItemClick} />
      <FullscreenPopup
        isOpened={isOpened}
        header={
          <AsideContentPopupHeader
            onClose={onClose}
            favoriteActions={INTERIOR_POPUP_FAVORITE_EVENT_ACTIONS}
            callAction="Open_jk_finish"
            dynamicCallTrackingTitle="InteriorDecoration"
          />
        }
        onClose={onClose}
        content={<Content title={item.title} description={item.description} images={item.images} />}
      />
    </Layout>
  );
}
